import { useRef, useState } from 'react';
import { FormInputProps } from '@/@types/form.types';
import EListPopupPickerWithSearchV2 from '@/components/everridge/EListPopupPickerWithSearchV2';
import { useSuperAdminDataHotelsLookupInfiniteApi } from '@/features/superAdmin/features/data/shared/hooks/useSuperAdminDataLookupsInfiniteApi';
import { useSuperAdminLookupInfiniteScroll } from '@/features/superAdmin/features/data/shared/lookups/useSuperAdminLookupInfiniteScroll';

type Props<T extends {}> = {
    tenantId?: string | null;
    selectVariant?: 'single' | 'multi';
    showSearch?: boolean;
    icon?: React.FC<React.SVGProps<SVGSVGElement>>;
    addResetButton?: boolean;
} & FormInputProps<T>;

const SuperAdminHotelLookup = <T extends {}>(props: Props<T>) => {
    const [searchValue, setSearchValue] = useState('');
    const {
        placeholder = 'Select hotel',
        label = 'Hotel',
        tenantId,
        addResetButton = true,
        disabled,
    } = props;
    const loaderRef = useRef<HTMLDivElement>(null);

    const { items, fetchNextPage, hasNextPage, isFetchingNextPage } =
        useSuperAdminDataHotelsLookupInfiniteApi(tenantId, searchValue);

    useSuperAdminLookupInfiniteScroll({
        loaderRef,
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage,
    });

    return (
        <EListPopupPickerWithSearchV2
            {...props}
            label={label}
            placeholder={placeholder}
            list={items}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            addResetButton={addResetButton}
            disabled={disabled || !tenantId}
            ref={loaderRef}
        />
    );
};

export default SuperAdminHotelLookup;
